import React, { useState } from 'react';
import './Hint.scss';

const Hint = (props) => {
  const {parametr, format, description } = props.hint;
  const [isShow, setIsShow] = useState(false);

  function showHint() {
    if(!isShow) return null;
    return (
      <div className="input-hint__info">
        <div className="input-hint__text-container">
          <span className="input-hint__text-title">Parametr: </span>
          <p className="input-hint__text">{parametr} </p>
        </div>
        <div className="input-hint__text-container">
          <span className="input-hint__text-title">Format: </span>
          <p className="input-hint__text">{format} </p>
        </div>
        <div className="input-hint__text-container">
          <span className="input-hint__text-title">Description: </span>
          <p className="input-hint__text">{description} </p>
        </div>
      </div>
    )
  }

  const handleMouseLeave = () => setIsShow(false);
  const handleMouseEnter = () => setIsShow(true);

  return (
    <div className="input-hint">
      <div
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="input-hint__icon"
      ></div>
      {showHint()}
    </div>
  );
};

export default Hint;
